import { GenericTableColumn } from "@ui-components/Table/GenericTable";

export interface Outages {
	eventId: string;
    date: string;
	site?: string;
	description: string;
	// Nullable: `null` means the outage is still active (auto-generated
	// by the watcher's router_unreachable / router_reachable pipeline —
	// duration is filled in once the router comes back).
	outageDuration: number | null;
	summary?: string;
	detail?: string;
	incidentId?: string;
}

export interface Maintenance {
	eventId: string;
    date: string;
	description: string;
	outageDuration: number;
}

export const maintenanceColumns: GenericTableColumn<Maintenance>[] = [
    {
        header: "Date",
        accessor: "date",
    },
    {
        header: "Maintenance Type",
        accessor: "description",
    },
    {
        header: "Duration",
        accessor: "outageDuration",
    }
];
